import { render } from "./SportClubs.vue?vue&type=template&id=f3c879f4"
import script from "./SportClubs.vue?vue&type=script&lang=js"
export * from "./SportClubs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__